import React, { createRef } from 'react'
import { Button } from 'antd'
import classNames from 'classnames'
import styles from './index.module.scss'


import { getContent } from '@/common/enter_content.js'
import { ContactsOutlined } from '@ant-design/icons'
import GifPlayer from "@/components/gif-player/index";

export default class Index extends React.PureComponent {
  videoRef = createRef()
    gifRef = createRef()

    imgSrcList = []
    index = 1
    lastIndex = 82
    framesNum = 50
    date = null

  state = {
      btnClick: false,
      btnShow: true,
      playing: false,
      imgSrc: ''
  }

    render () {
    const { onEnter, language } = this.props
        const className = classNames([
            styles.divaction,
            this.state.btnClick ? styles.imgdivaction :null
        ])
        const classNames1 = classNames([
            styles.img1,
            this.state.btnClick ? styles.img1action :null
        ])
        const classNames2 = classNames([
            styles.img2,
            this.state.btnClick ? styles.img2action :null
        ])
        const classNames3 = classNames([
            styles.img3,
            this.state.btnClick ? styles.img3action :null
        ])
    return (
      <div className={styles.wrap}>

        <div className={styles.videoBox}>
            <div className={className}>
            {/*<div className={styles.imgdivaction}>*/}
                <div className={styles.imgDiv}>
                    <img src={getContent(language, 'enter_circle_normal_mobile')} className={styles.img0} />
                </div>
                <div className={styles.imgDiv}>
                    <img src={getContent(language, 'enter_circle_normal_mobile')} className={classNames1} />
                </div>
                <div className={styles.imgDiv}>
                    <img src={getContent(language, 'enter_circle_normal_mobile')} className={classNames2} />
                </div>
                <div className={styles.imgDiv}>
                    <img src={getContent(language, 'enter_circle_normal_mobile')} className={classNames3} />
                </div>
                <div className={styles.imgDiv}>
                    <img src={getContent(language, 'enter_circle_normal_mobile')} className={styles.img4} />
                </div>
                <div className={styles.textDiv}>
                    <img className={language==='en'?styles.textTitleImg:styles.textTitleImgCh} src={getContent(language, 'enter_title_img')} />
                    {this.state.btnShow ? <Button className={styles.btn} type='info' //style={{display: !this.state.btnClick ? "absolute" : "none"}}
                                                  onClick={(e) => {
                                                      // alert('click two')
                                                      console.log('btn play')
                                                      this.setState({
                                                          btnClick: true,
                                                      })
                                                      setTimeout(() => {
                                                          onEnter()
                                                      },3.2*1000)
                                                  }
                                                  }>{ getContent(language, 'enter_btn_text') }</Button> : null}
                    <p className={language==='en'?styles.textContent:styles.textContentCh}>{getContent(language, 'enter_line1')}</p>
                    <p className={language==='en'?styles.textContent:styles.textContentCh}>{getContent(language, 'enter_line2')}</p>
                </div>
            </div>
            <div className={styles.backgroundDiv}><img src={getContent(language, 'enter_background_img')} className={styles.backgroundImg} /></div>
          </div>
          {/*<div className={styles.btnDiv}>*/}
          {/*    {this.state.btnShow ? <Button className={styles.btn} type='info' style={{display: !this.state.btnClick ? "absolute" : "none"}}*/}
          {/*                                  onClick={(e) => {*/}
          {/*                                      // alert('click two')*/}
          {/*                                      console.log('btn play')*/}
          {/*                                      this.setState({*/}
          {/*                                          btnClick: true,*/}
          {/*                                          btnShow: false*/}
          {/*                                      })*/}
          {/*                                      setTimeout(() => {*/}
          {/*                                        onEnter()*/}
          {/*                                      },3.2*1000)*/}
          {/*                                  }*/}
          {/*                                  }>{ getContent(language, 'enter_btn_text') }</Button> : null}*/}
          {/*</div>*/}


       </div>
    )
  }
}
